import React, { useState, useEffect } from "react";
import { MessageCircle, Phone, FileText, X } from "lucide-react";
import { buildWhatsAppUrl, buildTelUrl } from "../lib/whatsapp";

const DEFAULT_MSG = "Hi MY BEEMA, I'd like to get an insurance quote.";

export const WhatsAppFloat = ({ number = "919315542583", googleFormUrl = "" }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open && (
        <div
          className="bg-white rounded-2xl shadow-[0_20px_50px_-15px_rgba(11,25,44,0.35)] border border-[#E2E8F0] p-3 w-64 fade-up"
          data-testid="contact-menu"
        >
          <div className="px-2 py-1.5 text-[10px] uppercase tracking-[0.22em] font-bold text-[#006A4E]">
            Reach an advisor
          </div>
          <a
            data-testid="contact-menu-whatsapp"
            href={buildWhatsAppUrl(number, DEFAULT_MSG)}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#E6F0ED] transition-colors"
          >
            <MessageCircle className="w-5 h-5 text-[#25D366]" strokeWidth={1.6} />
            <div>
              <div className="text-sm font-semibold text-[#0B192C]">WhatsApp</div>
              <div className="text-[11px] text-[#4A5568]">Instant chat</div>
            </div>
          </a>
          <a
            data-testid="contact-menu-call"
            href={buildTelUrl(number)}
            className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#E6F0ED] transition-colors"
          >
            <Phone className="w-5 h-5 text-[#006A4E]" strokeWidth={1.6} />
            <div>
              <div className="text-sm font-semibold text-[#0B192C]">Call us</div>
              <div className="text-[11px] text-[#4A5568]">+91 93155 42583</div>
            </div>
          </a>
          {googleFormUrl && (
            <a
              data-testid="contact-menu-form"
              href={googleFormUrl}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#E6F0ED] transition-colors"
            >
              <FileText className="w-5 h-5 text-[#0B192C]" strokeWidth={1.6} />
              <div>
                <div className="text-sm font-semibold text-[#0B192C]">Google Form</div>
                <div className="text-[11px] text-[#4A5568]">Fill out enquiry form</div>
              </div>
            </a>
          )}
          <div className="px-3 pt-1 pb-0.5 text-[10px] text-[#4A5568]">
            WhatsApp blocked on your network? Use call or form.
          </div>
        </div>
      )}

      <button
        data-testid="whatsapp-float-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label={open ? "Close contact menu" : "Open contact options"}
        className={`${
          open ? "bg-[#0B192C]" : "bg-[#25D366] hover:bg-[#1ebe57]"
        } text-white rounded-full h-14 w-14 flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:shadow-[0_14px_36px_rgba(37,211,102,0.6)] hover:-translate-y-0.5 transition-all`}
      >
        {open ? <X className="w-6 h-6" strokeWidth={1.8} /> : <MessageCircle className="w-7 h-7" strokeWidth={1.8} />}
      </button>
    </div>
  );
};
